import { useEffect, useState } from 'react'
import Modal from 'react-modal'
import { ModerationContentType } from '@ivy-monorepo/shared'
import { BaseModalProps } from 'src/types/modal'
import { adminService } from '../../services/admin.service'

interface WarnUserModalProps extends BaseModalProps {
  userPublicId: string
  contentType: ModerationContentType
  contentReferenceId: string
  quotedContent: string
}

const WarnUserModal = ({
  isOpen,
  onClose,
  userPublicId,
  contentType,
  contentReferenceId,
  quotedContent,
}: WarnUserModalProps) => {
  const [moderatorNote, setModeratorNote] = useState('')
  const [isPending, setIsPending] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [success, setSuccess] = useState(false)

  useEffect(() => {
    if (!isOpen) return
    setModeratorNote('')
    setError(null)
    setSuccess(false)
  }, [isOpen])

  const handleWarn = async () => {
    try {
      setIsPending(true)
      setError(null)
      await adminService.warnUser(userPublicId, {
        contentType,
        contentReferenceId,
        quotedContent,
        moderatorNote: moderatorNote.trim() || undefined,
      })
      setSuccess(true)
      onClose()
    } catch {
      setError('Failed to send warning.')
    } finally {
      setIsPending(false)
    }
  }

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      ariaHideApp={false}
      className="modal-popup confirm-popup"
      overlayClassName="modal-overlay"
      shouldCloseOnEsc={!isPending}
      shouldCloseOnOverlayClick={!isPending}
    >
      <div className="modal-content-wrapper">
        <h2>Warn user</h2>
        <div className="form-group">
          <label>Quoted content</label>
          <div style={{ whiteSpace: 'pre-wrap', opacity: 0.9 }}>{quotedContent}</div>
        </div>
        <div className="form-group">
          <label>Moderator note (optional)</label>
          <textarea value={moderatorNote} onChange={e => setModeratorNote(e.target.value)} rows={3} disabled={isPending} />
        </div>
        {error && <div className="page-error">{error}</div>}
        {success && <div style={{ color: 'var(--success-color, green)' }}>Warning sent.</div>}
        <div className="modal-footer-content">
          <button type="button" className="styled-button" onClick={onClose} disabled={isPending}>
            Cancel
          </button>
          <button type="button" className="styled-button" onClick={handleWarn} disabled={isPending}>
            {isPending ? 'Sending…' : 'Send warning'}
          </button>
        </div>
      </div>
    </Modal>
  )
}

export default WarnUserModal
